import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";

import INFO from "../data/user";
import SEO from "../data/seo";

const Resume = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "resume");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Resume | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="mt-12">
				<NavBar active="resume" />
				<div className="content-wrapper">
					<div className="articles-logo">
						<Logo width={46} />
					</div>

					<div className="title my-12">
						View and download my resume
					</div>

					<div className="container p-[10%] border-2 rounded-lg">
						<div className="position flex justify-center my-[2%]">
							<p className="font-bold text-2xl">
								{INFO.main.name} - Web Developer
							</p>
						</div>
						<div className="header">
							<p className="flex flex-wrap justify-center">
								{INFO.main.location}
								{`\xa0`}|{`\xa0`}
								<a
									className="text-blue-500 underline"
									href={INFO.main.email}
								>
									{INFO.main.email}
								</a>
								{`\xa0`}|{`\xa0`}
								<a
									className="text-blue-500 underline"
									href={INFO.socials.github}
								>
									{INFO.socials.github}
								</a>
								{`\xa0`}|{`\xa0`}
								<a
									className="text-blue-500 underline"
									href={INFO.socials.linkedin}
								>
									{INFO.socials.linkedin}
								</a>
							</p>
						</div>

						<div className="education">
							<h2 className="font-bold text-lg mb-2 mt-6">
								Education
							</h2>
							<p className="text-sm">09/2020-12/2024</p>

							<h2 className="font-semibold">
								University Of Massachusetts - Boston
							</h2>
							<h2 className="ml-1 text-sm">
								B.S Computer Science
							</h2>

							<ul className="list-disc ml-[10%]">
								<li className="flex">
									<p>
										<strong>
											Relevant Coursework:{`\xa0`}
										</strong>
										Software Engineering, Computer Graphics,
										Internetworking, UI/UX Design
									</p>
								</li>
								<li className="flex">
									<strong>Involvement:{`\xa0`}</strong>
									<p>CS Club, Math Club, Chess Club</p>
								</li>
							</ul>

							<p className="text-sm mt-4">08/2023</p>
							<h2 className="font-semibold">
								Fullstack Web Development Bootcamp
							</h2>
							<h2 className="ml-1 text-sm">
								By Colt Steele - 94hrs
							</h2>

							<ul className="list-disc ml-[10%] mb-[]">
								<li>
									<strong>Completed{`\xa0`}</strong>a 94-hour
									hands-on web development bootcamp, mastering
									full-stack skills in the MERN stack, unit
									testing, and API development.
								</li>
							</ul>
						</div>

						<div className="projects space-y-[2%] my-[2%]">
							<h2 className="font-bold text-lg mb-2 mt-6">
								Projects
							</h2>

							<div className="mySite">
								<div className="flex flex-col">
									<strong className="text-nowrap">
										Portfolio Website
									</strong>

									<ul className="list-disc ml-[10%] mb-[]">
										<li>
											<strong>
												Developed a dynamic portfolio
												website{`\xa0`}
											</strong>
											using React, showcasing personal
											projects and achievements, with a
											focus on responsive design and UX.
										</li>

										<li>
											<strong>Link {`\xa0`}</strong>
											<a
												className="ml-1 text-blue-500"
												href="https://woooocoder.github.io/mySite/"
											>
												https://woooocoder.github.io/mySite/
											</a>
										</li>
									</ul>
								</div>
							</div>

							<div className="mySite mb-0.5">
								<div className="flex flex-col">
									<strong className="text-nowrap">
										Boulder Flash (WIP)
									</strong>
									<ul className="list-disc ml-[10%] mb-[]">
										<li>
											<strong>
												Led a 2-week scrum {`\xa0`}
											</strong>
											assigning rotating roles amongst
											peers, analyzing needs, and
											constructing a user/task analysis,
											followed by a Figma prototype.
										</li>

										<li>
											<strong>
												Developed the front end {`\xa0`}
											</strong>
											with a keen emphasis on usability
											and design heuristics, ensuring a
											user-friendly interface to log,
											share and generate statistics about
											your rock climbing sessions.
										</li>

										<li>
											<strong>Link: {`\xa0`}</strong>
											<a
												className="ml-1 text-blue-500"
												href="https://github.com/woooocoder/boulder-flash"
											>
												https://github.com/woooocoder/boulder-flash
											</a>
										</li>
									</ul>
								</div>
							</div>

							<div className="mySite mb-0.5">
								<div className="flex flex-col">
									<strong className="text-nowrap">
										YelpCamp
									</strong>
									<ul className="list-disc ml-[10%] mb-[]">
										<li>
											<strong>
												Designed a scalable backend{" "}
												{`\xa0`}
											</strong>
											with two servers handling
											authentication and server-side
											rendering, and modeled a
											non-relational database synchronized
											with each server's API.
										</li>

										<li>
											<strong>
												Implemented third-party services{" "}
												{`\xa0`}
											</strong>
											such as Cloudinary for image
											management and MapQuest for
											geolocation features
										</li>

										<li>
											<strong>Link {`\xa0`}</strong>
											<a
												className="ml-1 text-blue-500"
												href="https://github.com/woooocoder/boulder-flash"
											>
												https://github.com/woooocoder/boulder-flash
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>

						<div className="projects space-y-[2%] my-[2%]">
							<h2 className="font-bold text-lg mb-2 mt-6">
								Experience
							</h2>

							<div className="mySite">
								<div className="flex flex-col">
									<strong className="text-nowrap">
										Reese Phone Repair
									</strong>
									<div className="text-sm">Self Employed</div>

									<ul className="list-disc ml-[10%] mb-[]">
										<li>
											<strong>
											Troubleshooted and repaired 400+{`\xa0`}
											</strong>
											electronic devices, ensuring optimal performance and customer satisfaction.
										</li>

										<li>
											<strong>
											Built and customized 250+{`\xa0`}
											</strong>
											PCs to meet specific user requirements, demonstrating a strong understanding of hardware and software integration.
										</li>

										<li>
											<strong>
											Configured 300+{`\xa0`}
											</strong>
											Windows, Linux and Mac operating systems, providing a seamless user experience for customers.
										</li>
									</ul>
								</div>
							</div>
						</div>

						 
						<div className="skills mb-[4%]">
							<h2 className="font-bold text-lg mb-2 mt-6">
								Technical Skills
							</h2>

							<p>
								<strong>Languages: {`\xa0`}</strong>
								Javascript, Java, CSS, HTML, Typescript, .NET,
								C, C#, Python
							</p>

							<p>
								<strong>Frameworks: {`\xa0`}</strong>
								React, Express, Node, Java Spring Boot, Flask,
								WordPress
							</p>

							<p>
								<strong>
									Deployment & Databases: {`\xa0`}
								</strong>
								UNIX, Google Cloud, IBM Cloud, Git, Heroku,
								Firebase, FastAPI, MongoDB, SQL
							</p>
						</div>

						<div className="skills mb-[4%]">
							<h2 className="font-bold text-lg mb-2 mt-6">
								Interests
							</h2>

							<p>
								Chess, Rock Climbing, Journaling, Machine Learning, Snowboarding	
							</p>
						</div>
					</div>

					<div className="flex justify-center w-full">
						<a
							href="./SWE_Resume.pdf"
							download="Woodrow_Reese_Resume.pdf"
							className="rounded-xl shadow-md w-min px-4 py-1 mt-6 font-semibold hover:text-[#14b8a6]"
						>
							Download
						</a>
					</div>

					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Resume;
